<ng-container *transloco="let t">
  @let paymentLinkValue = paymentLink();

  @if (paymentMethod()) {
    <div class="order-section-item">
      <div class="order-section-item-title">
        {{ t('orderDetails.paymentMethod') }}
      </div>
      <div class="order-section-item-value">
        {{ paymentMethod().name }}
      </div>
    </div>

    @if (paymentMethod().type === 'CASH' && howMuch()) {
      <div class="order-section-item">
        <div class="order-section-item-title">
          {{ t('orderDetails.paymentHowMuch') }}
        </div>
        <div class="order-section-item-value">
          {{ howMuch()! | currencyFormat }}
        </div>
      </div>
    }
    @if (paymentLinkValue) {
      @if (paymentUrl()) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.paymentLink') }}
          </div>
          <div class="order-section-item-value">
            <a [href]="paymentUrl()" target="blank">{{ t('orderDetails.openPaymentLink') }}</a>
          </div>
        </div>
      }
      @if (paymentLinkValue.status) {
        <div class="order-section-item">
          <div class="order-section-item-title">{{ t('paymentStatus.title') }}</div>
          <div class="order-section-item-value">
            <pxw-tag [type]="paymentTagType()" size="xs">
              <pxw-icon icon="payment" />
              <!-- t(paymentStatus.PAID,paymentStatus.PENDING,paymentStatus.CANCELLED,paymentStatus.REFUNDED,paymentStatus.REJECTED)-->
              {{ t('paymentStatus.' + paymentLinkValue.status) }}
            </pxw-tag>
          </div>
        </div>
      }
      @if (paymentLinkValue.updated) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('paymentStatus.lastUpdated') }}
          </div>
          <div class="order-section-item-value">
            {{ paymentLinkValue.updated | date: 'dd/MM/yy - HH:mm' }}hs
          </div>
        </div>
      }
    }
  }
</ng-container>
